import React, { useState } from 'react';
import './DataCatalog.css';
import cubo from '../assets/icons/cubo1.png';
import docu from '../assets/icons/archivo.png';
import Modal from '../components/Modal';
import { useTranslation } from 'react-i18next';
import { calcFontSize } from '../utils/common';
import { URL } from '../utils/constants';

const DataCatalog = ({ navigate }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [modalSource, setModalSource] = useState('');

  const handleCloseModal = () => {
    setShowModal(false);
    setModalSource('');
  };

  const handleGTFSClick = (url) => {
    window.top.location.href = url;
  };

  return (
    <div className="data-catalog">
      <table style={{ fontSize: calcFontSize(14) }} className="data-table">
        <thead>
          <tr className='titles'>
            <th scope="col" className='thNoTitle'></th>
            <th scope="col" className='thFitxer'>{t("dataCatalog.tableTitleService")}</th>
            <th scope="col" className='thFormats'>{t("dataCatalog.tableTitleFormat")}</th>
            <th scope="col" className='thAcces'>{t("dataCatalog.tableTitleAccess")}</th>
          </tr>
        </thead>
        <tbody>
          {[/* {
            id: 1,
            label: "dataCatalog.serviceGTFSRT",
            url: URL.urlRt,
            formats: ['GTFS', 'PB', 'JSON'],
            access: "dataCatalog.accessDescription",
            classname: 'trNotitle1',
            disabled: true
          }, */ {
            id: 1,
            label: "dataCatalog.alertService",
            url: URL.urlAlertJSON,
            formats: ['GTFS', 'JSON'],
            access: "dataCatalog.accessLink",
            classname: 'trNotitle1',
          },{
            id: 2,
            label: "dataCatalog.alertService",
            url: URL.urlAlertPB,
            formats: ['GTFS', 'PB'],
            access: "dataCatalog.downloadLink",
            classname: 'trNotitle2'
          }, {
            id: 3,
            label: "dataCatalog.tripUpdates",
            url: URL.urlTripUpJSON,
            formats: ['GTFS', 'JSON'],
            access: "dataCatalog.accessLink",
            classname: 'trNotitle1',
          }, {
            id: 4,
            label: "dataCatalog.tripUpdates",
            url: URL.urlTripUpPB,
            formats: ['GTFS', 'PB'],
            access: "dataCatalog.downloadLink",
            classname: 'trNotitle2'
          },{
            id: 5,
            label: "dataCatalog.GTFSstatic",
            url: URL.urlStatic,
            formats: ['GTFS', 'ZIP', 'CSV'],
            access: "dataCatalog.accessDescriptionStatic",
            classname: 'trNotitle2'
          }, {
            id: 6,
            label: "dataCatalog.GTFSstaticComplete",
            url: URL.urlStaticCru,
            formats: ['GTFS', 'ZIP', 'CSV'],
            access: "dataCatalog.accessDescriptionStatic",
            classname: 'trNotitle3'
          }].map(({ id, label, url, formats, access, classname, disabled }) => (
            <tr key={id} className={classname} style={{opacity: disabled ? 0.2 : 1 }}>
              <td className='tdContainer' style={{ display: 'flex', alignItems: 'center' }}>
                <span className='arrow' aria-hidden="true" style={{ flexShrink: 0, display: 'flex', alignItems: 'center' }}>➔</span>
                <button
                  className='spanLink'
                  onClick={() => handleGTFSClick(url)}
                  onKeyDown={(e) => e.key === 'Enter' && handleGTFSClick(url)}
                  aria-label={t(label)}
                  style={{ background: 'none', border: 'none', cursor: disabled ? 'default' : 'pointer', color: 'inherit', flexGrow: 1, textAlign: 'left' }}
                  disabled={disabled}
                >
                  {t(label)}
                </button>
              </td>
              <td className={disabled ? 'backGrey1' : 'backGrey'}>
                <img src={(id === 1 || id === 3) ? cubo : docu} alt="" className='iconImage' aria-hidden="true" />
              </td>
              <td className='tdContainerFormats'>
                {formats.map((format, index) => (
                  <div key={index} className={`pastilla${format}`} style={{ fontSize: calcFontSize(10) }}>{format}</div>
                ))}
              </td>
              <td className={disabled ? 'backGrey1' : 'backGrey'} style={{ alignContent: 'center' }}>
                <button
                  onClick={() => handleGTFSClick(url)}
                  onKeyDown={(e) => e.key === 'Enter' && handleGTFSClick(url)}
                  className="access-button"
                  disabled={disabled}
                  style={{ background: 'none', border: 'none', cursor: disabled ? 'not-allowed' : 'pointer', color: 'inherit' }}

                >
                  {disabled ? t("dataCatalog.disabledAccess") : t(access)}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal show={showModal} onClose={handleCloseModal} source={modalSource} />
    </div>
  );
};

export default DataCatalog;